module.exports = __webpack_public_path__ + "media/images/partners/house_of_europe-3da8f80c4293ffd3e83f3a8d04f9f014.png";